/* eslint-disable react/display-name */
// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React from 'react'
import { APIStatus, API_FETCHING } from '@nw/api-constants'
import 'styled-components/macro'

import { FileUploader } from '../FileUploader/FileUploader'
import { Loader } from '../Loader'
import {
  FileUploaderContainer,
  FileUploaderSection,
  StyledLabel
} from './styledComponents'

import { Hint } from '../Hint'

interface FileUploaderProps {
  setFieldValue: any
  field: string
  overrideBucketPath?: string
  label: string
  error?: any
  touched?: any
  value: string
  isDisabled?: boolean
  userName?: string
  handleBlur?: any
  t?: any
  fileUploader
  extraBucketPath?: string
  getCustomFileName: any
  onDeleteSuccess?: () => void
  helperText?: string
  shouldShowDeleteButton?: boolean
  labelTextCSS?: React.CSSProperties
  styledHintClassName?: string
}

interface FileUploaderUiProps {
  fileUploadStatus: APIStatus
  value: string
  isNotValid: boolean
  t: any
}

export const FileUploaderUi = React.memo((fieldProps: FileUploaderUiProps) => {
  const { fileUploadStatus, value, isNotValid, t } = fieldProps
  let name = ''
  if (value) {
    const extractedPathsFromUrl = value.split('/')
    name = extractedPathsFromUrl[extractedPathsFromUrl.length - 1]
  }

  let fileUploaderValue: any = ''
  switch (fileUploadStatus) {
    case API_FETCHING:
      fileUploaderValue = <Loader />
      break
    default:
      fileUploaderValue = name ? name : t('placeholder.chooseAFileToUpload')
  }

  return (
    <FileUploaderContainer>
      <FileUploaderSection isNotValid={isNotValid}>
        {fileUploaderValue}
      </FileUploaderSection>
    </FileUploaderContainer>
  )
})

export const FileUploaderField = React.memo((fieldProps: FileUploaderProps) => {
  const {
    setFieldValue,
    label,
    error,
    touched,
    fileUploader,
    overrideBucketPath,
    extraBucketPath,
    getCustomFileName,
    onDeleteSuccess,
    helperText,
    value,
    isDisabled,
    shouldShowDeleteButton,
    labelTextCSS,
    styledHintClassName
  } = fieldProps

  const isNotValid = touched && error ? true : false
  const errorText = isNotValid ? error : ''
  const renderFileUploaderField = () => (
    <>
      <StyledLabel css={labelTextCSS}>{label}</StyledLabel>
      <FileUploader
        fileUploaderInfo={fileUploader}
        onSuccessFileUpload={setFieldValue}
        isNotValid={isNotValid}
        overrideBucketPath={overrideBucketPath}
        extraBucketPath={extraBucketPath}
        getCustomFileName={getCustomFileName}
        onDeleteSuccess={onDeleteSuccess}
        value={value}
        isDisabled={isDisabled}
        shouldShowDeleteButton={shouldShowDeleteButton}
      />
      <Hint
        id="file-uploader-field"
        errorText={errorText}
        hint={helperText}
        styledHintClassName={styledHintClassName}
      />
    </>
  )

  return <div>{renderFileUploaderField()}</div>
})
